import React, { PureComponent } from 'react'
import { get } from 'lodash'
import fieldsMap, { getFieldWidth } from './fieldsMap'

import Form from '../../form'

const FormItem = Form.Item

const isInput = (type) => ['input', 'string', 'search'].includes(type)

export default class Field extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      value: props.initialValue,
    }
  }

  render() {
    const {
      type = 'input',
      title,
      name,
      isFieldInDrawer = false,
      className = '',
      component,
      form,
      props: fieldProps,
    } = this.props
    const { value } = this.state
    const Field = component || fieldsMap[type]

    return (
      <FormItem label={title} className={className}>
        <Field
          value={value}
          {...(isInput(type)
            ? {
                onPressEnter: (evt) =>
                  form.emit('search', { [name]: evt?.target?.value, current: 1 }),
              }
            : {})}
          {...fieldProps}
          style={{
            ...fieldProps?.style,
            width: isFieldInDrawer ? '100%' : fieldProps?.style?.width || getFieldWidth(type),
          }}
          onChange={this.onChange}
        />
      </FormItem>
    )
  }

  updateValue = (name, value) => {
    if (name === this.props.name) {
      this.setState({ value })
      this.props.onChange(name, value)
    }
  }

  onChange = (...args) => {
    const { name, type = 'input', component, props: fieldProps } = this.props
    const { onChange } = fieldProps || {}

    onChange && onChange(...args)

    // Input onChange第一个参数为Event对象，取值特殊处理
    if (!component && isInput(type)) {
      args[0] = get(args[0], 'target.value')
    }

    this.setState({ value: args[0] })
    this.props.onChange(name, args[0])
  }

  onFormChange = (formData) => {
    this.setState({
      value: get(formData, this.props.name),
    })
  }

  componentDidMount() {
    const { form } = this.props

    form.on('setValue', this.updateValue)
    form.on('setValues', this.onFormChange)
  }

  componentWillUnmount() {
    const { form } = this.props

    form.off('setValue', this.updateValue)
    form.off('setValues', this.onFormChange)
  }
}
